import React from "react";
import { Alert } from "antd";

const WarningMessage = ({ message = "" }) => <Alert message={message} banner />;
export default WarningMessage;
